<template>
	<div class="inline-editor">
		<editor-menu-bar :editor="editor" v-slot="{ commands, isActive, focused }">
			<div
				class="menubar is-hidden"
				:class="{ 'is-focused': focused }"
			>

				<button
					class="btn btn-plain mb-0"
					:class="{ 'is-active': isActive.bold() }"
					@click="commands.bold"
					>
					<i class="material-icons">format_bold</i>
				</button>

				<button
					class="btn btn-plain mb-0"
					:class="{ 'is-active': isActive.italic() }"
					@click="commands.italic"
				>
					<i class="material-icons">format_italic</i>
				</button>

				<button
					class="btn btn-plain mb-0"
					:class="{ 'is-active': isActive.strike() }"
					@click="commands.strike"
					>
					<i class="material-icons">strikethrough_s</i>
				</button>
			</div>
		</editor-menu-bar>

		<editor-content class="editor-content" :editor="editor" />
	</div>
</template>

<script>
// import Icon from 'Components/Icon';
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import {
	Blockquote,
	BulletList,
	CodeBlock,
	HardBreak,
	Heading,
	ListItem,
	OrderedList,
	TodoItem,
	TodoList,
	Bold,
	Code,
	Italic,
	Link,
	Strike,
	Underline,
	History,
} from 'tiptap-extensions';
// eslint-disable-next-line
import { mapGetters } from 'vuex';
// eslint-disable-next-line
import Align from '@/lib/tiptap/align';
// eslint-disable-next-line
import Color from '@/lib/tiptap/color';
import BackgroundColor from '@/lib/tiptap/bgColor';

import {
	nl2p,
	// eslint-disable-next-line
	removeHtmlTags
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	props: ['value'],
	components: {
		EditorContent,
		EditorMenuBar,
		// Icon,
	},
	data() {
		return {
			editor: null,
			isEditable: true,
		};
	},
	computed: {
		...mapGetters({
			isDragging: 'funnels/isDragging',
		}),
	},
	watch: {
		value(newValue) {
			const html = this.editor.getHTML();
			if (html !== this.value) {
				this.editor.setContent(newValue);
			}
		},
		isDragging(dragging) {
			if (dragging) {
				this.isEditable = false;
			} else {
				this.isEditable = true;
			}

			this.editor.setOptions({
				editable: this.isEditable,
			});
		},
	},
	methods: {
		initEditor() {
			let content = this.value;
			const isFormatted = content.indexOf('<p>') === 0;
			if (!isFormatted) {
				content = nl2p(content);
			}
			// const content = this.value;
			const extensions = [
				new Blockquote(),
				new BulletList(),
				new CodeBlock(),
				new HardBreak(),
				new Heading({ levels: [1, 2, 3] }),
				new ListItem(),
				new OrderedList(),
				new TodoItem(),
				new TodoList(),
				new Link(),
				new Bold(),
				new Code(),
				new Italic(),
				new Strike(),
				new Underline(),
				new History(),
				new Align(),
				new Color(),
				new BackgroundColor(),
			];
			this.editor = new Editor({
				content,
				extensions,
				onUpdate: this.onUpdate,
				editable: this.isEditable,
				onFocus: this.focus,
			});
		},
		onUpdate(editor) {
			const value = editor.getHTML();
			this.$emit('input', value);
		},
		focus() {
			this.$emit('focus', true);
		},
	},
	mounted() {
		this.initEditor();
	},
	beforeDestroy() {
		this.editor.destroy();
	},
};
</script>
<style lang="scss">
.inline-editor {

	.ProseMirror {
		position: relative;
		padding: 0 !important;
		max-height: 100% !important;
		border-radius: 0px;
		background: transparent !important;
		border: 1px solid transparent !important;
		overflow: hidden !important;

		p {
			min-height: 1.2em;

			&:last-child {
				margin-bottom: 0 !important;
			}
		}
	}

	.menubar {
		background: #ddd;
		border-radius: 3px;
		line-height: 1.5 !important;
		font-size: 14px !important;

		.btn {
			border-radius: 0;

			&.is-active {
				background: #bababa;
			}
		}

		&.is-hidden {
			position: absolute;
			visibility: hidden;
			opacity: 0;
			margin-top: -40px;
		}

		&.is-focused {
			visibility:visible;
			opacity:1;
			-webkit-transition:visibility .2s,
			opacity .2s;
			transition:visibility .2s,
			opacity .2s
		}
	}

}

</style>
